import styled from '@emotion/styled';
import { Button } from '@anyroad/button';
import { colors } from '@anyroad/theme';

const MOBILE_BREAKPOINT = 768;

export const RescheduleModalContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  lineHeight: 1.4,
  fontSize: '14px',
});

export const RescheduleModalHeader = styled.div({
  display: 'flex',
  justifyContent: 'center',
  fontSize: '16px',
  fontWeight: 'bold',
  marginBottom: '1rem',
});

export const ColumnsContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  gap: '1.5rem',
  marginTop: '1rem',
  marginBottom: '1.5rem',
  [`@media (max-width: ${MOBILE_BREAKPOINT - 1}px)`]: {
    flexDirection: 'column',
    gap: '1rem',
    marginTop: '0.75rem',
    marginBottom: '1rem',
  },
});

export const CurrentBookingWrapper = styled.div({
  flex: 0.85,
  padding: '1rem',
  borderRight: `1px solid ${colors.border}`,
  [`@media (max-width: ${MOBILE_BREAKPOINT - 1}px)`]: {
    flex: 'none',
    width: '100%',
    borderRight: 'none',
    borderBottom: `1px solid ${colors.border}`,
    padding: '0.75rem 0 1rem',
    marginBottom: '0.25rem',
  },
});

export const ColumnHeader = styled.div({
  fontSize: '14px',
  color: colors.text.secondary,
  marginBottom: '0.5rem',
  [`@media (max-width: ${MOBILE_BREAKPOINT - 1}px)`]: {
    marginBottom: '0.375rem',
  },
});

export const RescheduleBookingColumn = styled.div({
  flex: 1,
  padding: '1rem',
  [`@media (max-width: ${MOBILE_BREAKPOINT - 1}px)`]: {
    flex: 'none',
    width: '100%',
    padding: '0 0 0.5rem',
  },
});

export const ButtonContainerStyle = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: colors.primary,
  borderRadius: '6px',
});

export const BookingName = styled.div({
  fontSize: '15px',
  fontWeight: 'bold',
});

export const BookingGuests = styled.div({
  fontSize: '14px',
  color: colors.text.primary,
});

export const BookingDate = styled.div({
  fontSize: '14px',
  color: colors.text.primary,
});

export const SaveButton = styled.div({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '1rem',
});

export const Label = styled.label({
  display: 'block',
  fontWeight: 500,
  marginBottom: '8px',
  color: colors.text.primary,
  fontSize: '14px',
  [`@media (max-width: ${MOBILE_BREAKPOINT - 1}px)`]: {
    marginBottom: '6px',
  },
});

export const DateSelectRow = styled.div({
  width: '70%',
  marginBottom: '20px',
  [`@media (max-width: ${MOBILE_BREAKPOINT - 1}px)`]: {
    width: '100%',
    marginBottom: '16px',
  },
});

export const TimeSelectRow = styled.div({
  width: '100%',
  [`@media (max-width: ${MOBILE_BREAKPOINT - 1}px)`]: {
    marginTop: '4px',
  },
});

export const SpinnerContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
});

export const TimeSlotsErrorContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '0.75rem',
});

export const TimeSlotsErrorLabel = styled.div({
  display: 'block',
  fontWeight: 500,
  marginBottom: '8px',
  fontSize: '14px',
  color: colors.error,
});

export const ExperiencePricingRulesContainer = styled.div({
  marginTop: '16px',
});

export const PaymentDetailsContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

export const PaymentDetailsError = styled.div({
  fontSize: '14px',
  color: colors.error,
  marginBottom: '1rem',
});

export const PaymentDetailsHeader = styled.div({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '18px',
  lineHeight: '24px',
  fontWeight: 600,
  marginBottom: '0.5rem',
  color: colors.text.primary,
});

export const BackButton = styled.button({
  position: 'absolute',
  left: 0,
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  fontSize: '14px',
  color: colors.text.primary,
});

export const AmountRow = styled.div({
  border: `1px solid ${colors.border}`,
  borderRadius: '8px',
  padding: '10px',
  display: 'flex',
  flexDirection: 'column',
  width: '300px',
  margin: '10px 5px 10px 0px',
});

export const AmountLabelValueRow = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const AmountLabel = styled.span({
  fontSize: '16px',
  lineHeight: '20px',
  fontWeight: 600,
  color: colors.text.primary,
});

export const AmountValueContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto',
  gap: '4px',
});

export const ExpandedPaymentSection = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '300px',
});

export const ExpandedRow = styled.div({
  display: 'flex',
  alignItems: 'baseline',
});

export const ExpandedLabel = styled.span({
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: 400,
  color: colors.text.primary,
});

export const ExpandedLabelDescription = styled.div({
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 400,
  color: colors.text.secondary,
  marginTop: '2px',
});

export const SubtotalLine = styled.div({
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 400,
  color: colors.text.secondary,
  marginTop: '2px',
  '&:first-of-type': { marginTop: '2px' },
});

export const ExpandedValue = styled.span({
  fontSize: '14px',
  lineHeight: '100%',
  fontWeight: 400,
  marginLeft: 'auto',
  color: colors.text.primary,
});

export const AmountValue = styled.span<{ isRefund?: boolean }>(
  ({ isRefund }) => ({
    fontSize: '14px',
    lineHeight: '100%',
    fontWeight: 400,
    color: isRefund ? colors.text.primary : colors.error,
  })
);

export const SectionLabel = styled.div({
  fontSize: '16px',
  lineHeight: '20px',
  fontWeight: 600,
  color: colors.text.primary,
  marginBottom: '8px',
});

export const SectionValue = styled.div({
  fontSize: '16px',
  lineHeight: '100%',
  fontWeight: 400,
  color: colors.text.primary,
  margin: '20px 0',
});

export const RefundTimingNote = styled.div({
  fontSize: '16px',
  lineHeight: '100%',
  fontWeight: 400,
  color: colors.text.primary,
  margin: '12px 0',
});

export const PriceChangeNote = styled.div({
  fontSize: '14px',
  lineHeight: 1.4,
  fontWeight: 400,
  color: colors.text.secondary,
  marginBottom: '0.75rem',
});

export const BookingUpdatedContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1rem',
  width: '100%',
  textAlign: 'center',
});

export const BookingUpdatedHeader = styled.div({
  fontSize: '16px',
  fontWeight: 'bold',
});

export const BookingUpdatedMessage = styled.p({
  fontSize: '14px',
  color: colors.text.primary,
  lineHeight: 1.5,
  margin: 0,
});

export const ConfirmButtonRow = styled.div({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '1rem',
});

export const ConfirmButton = styled(Button)({
  width: '200px',
  minHeight: '44px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:disabled': {
    opacity: 0.5,
    cursor: 'not-allowed',
    pointerEvents: 'none',
  },
});

export const DashedDivider = styled.div({
  width: '100%',
  height: '1px',
  margin: '1rem 0',
  borderTop: '1px dashed #E0E0E0',
});

export const Divider = styled.div({
  width: '100%',
  height: '1px',
  backgroundColor: colors.border,
  margin: '1rem 0',
});

export const UpdatedMessage = styled.div({
  fontSize: '14px',
  lineHeight: '100%',
  fontWeight: 400,
  color: colors.text.primary,
  margin: '20px 0',
});
